module.exports = __webpack_public_path__ + "static/media/12UNCTAD8.ad23e75b.jpg";